'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactRedux = require('react-redux');

var _nuiIntl = require('@concur/nui-intl');

var _nuiIntl2 = _interopRequireDefault(_nuiIntl);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _listingsModule = require('./listingsModule');

var ListingsActions = _interopRequireWildcard(_listingsModule);

!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require('./style/listings.css') : void 0;

var _Header = require('../shared/Header');

var _Header2 = _interopRequireDefault(_Header);

var _CommonSections = require('../shared/CommonSections');

var _CommonSections2 = _interopRequireDefault(_CommonSections);

var _utils = require('../utils');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Home = function (_Component) {
  _inherits(Home, _Component);

  function Home() {
    _classCallCheck(this, Home);

    return _possibleConstructorReturn(this, (Home.__proto__ || Object.getPrototypeOf(Home)).apply(this, arguments));
  }

  _createClass(Home, [{
    key: 'componentDidMount',


    // static readyOnActions(dispatch, location, params) {
    //   /* Below is run server-side */
    //   return [
    //     () => dispatch(ListingsActions.fetchListingsIfNeeded()),
    //     () => dispatch(ListingsActions.fetchCategoriesIfNeeded()),
    //   ];
    // }

    value: function componentDidMount() {
      var categorySlug = (0, _get3.default)(this.props, 'params.category');
      if (categorySlug) this.props.setCategorySlug(categorySlug);

      if (this.context.isPublic && (0, _utils.canUseDOM)() && window.utag) {
        (0, _utils.sendPublicView)();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps() {
      var categorySlug = (0, _get3.default)(this.props, 'params.category');

      if (categorySlug) {
        if (this.props.listings.categories.length > 0) {
          var isValidCategory = this.props.listings.categories.some(function (category) {
            var subCategoryMatch = false;
            if (category.subcategories.length > 0) {
              subCategoryMatch = category.subcategories.some(function (subCategory) {
                return subCategory.slug.toLowerCase() === categorySlug.toLowerCase();
              });
            }
            return subCategoryMatch || category.slug.toLowerCase() === categorySlug.toLowerCase();
          });

          if (!isValidCategory) window.location = '/404';
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var localeData = (0, _nuiIntl.getLocaleData)(this.props);
      var translations = window.NUI_TRANSLATIONS; // eslint-disable-line global-require, import/no-dynamic-require

      return _react2.default.createElement(
        _nuiIntl2.default,
        { messages: translations, localeData: localeData },
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_Header2.default, { enableLiveSearch: true }),
          _react2.default.createElement(_CommonSections2.default, { enableLiveUpdate: true })
        )
      );
    }
  }]);

  return Home;
}(_react.Component);

Home.propTypes = {
  // dispatch: React.PropTypes.func,
  // location: React.PropTypes.any,
  // params: React.PropTypes.any,
  listings: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  setCategorySlug: _propTypes2.default.func
};

Home.contextTypes = {
  isPublic: _propTypes2.default.bool,
  getTitle: _propTypes2.default.func
};

function mapStateToProps(state) {
  return {
    listings: state.listings,
    userPrefs: state.userPrefs
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, {
  setCategorySlug: ListingsActions.setCategorySlug
})(Home);


//////////////////
// WEBPACK FOOTER
// ./lib/listings/ListingsContainer.js
// module id = 562
// module chunks = 0